import { render, staticRenderFns, recyclableRender, components } from "./withdrawal-successful.vue?vue&type=template&id=19e810ac&scoped=true&"
var renderjs
import script from "./withdrawal-successful.vue?vue&type=script&lang=js&"
export * from "./withdrawal-successful.vue?vue&type=script&lang=js&"
import style0 from "./withdrawal-successful.vue?vue&type=style&index=0&id=19e810ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e810ac",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/withdrawal-successful/withdrawal-successful.vue"
export default component.exports